exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prop-title[data-v-a5c6706c]{text-decoration:underline;cursor:pointer}", ""]);

// exports
